import { render } from "./Normativity.html?vue&type=template&id=f5f7b74e&ts=true"
import script from "./Normativity.vue?vue&type=script&lang=ts"
export * from "./Normativity.vue?vue&type=script&lang=ts"

import "./Normativity.vue?vue&type=style&index=0&id=f5f7b74e&lang=css"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__